// removed by extract-text-webpack-plugin
module.exports = {"videoLoop":"dh-video-videoLoop","videoLoop__fallbackImage":"dh-video-videoLoop__fallbackImage","videoLoop--showFallbackImage":"dh-video-videoLoop--showFallbackImage","videoLoop__videoElement":"dh-video-videoLoop__videoElement"};


//////////////////
// WEBPACK FOOTER
// ./src/article/components/VideoLoop.css
// module id = 10
// module chunks = 1